import { ListButton, Show } from "@refinedev/antd";
import { Card, Checkbox, Form, Spin } from "antd";
import React from "react";
import ExploreQueryNew from "@src/pages/dashboard/components/explore-builder-new";
import { useNavigation } from "@refinedev/core";
import { ChartResultProvider } from "./form/chart-result-provider";
import { GeneralInfoWrapper } from "./form/general-info-wrapper";
import { QueryBuilderChartLayout } from "@src/layouts/firebase-explore/query-builder-chart-layout";
import { useExploreContext } from "@src/contexts/explore-context";

export const FirebaseExploreShareView: React.FC = () => {
  const { push } = useNavigation();
  const { form: formContext, exploration, isLoading } = useExploreContext();
  const [_form] = Form.useForm();
  const form = formContext ?? _form;

  const formLoading = Form.useWatch("form_loading", form);
  if (isLoading) return <Spin />;
  return (
    <Show
      isLoading={isLoading || !!formLoading}
      title="View exploration"
      headerButtons={<ListButton onClick={() => push("/")}>Explorations</ListButton>}
      contentProps={{
        className: "bg-transparent shadow-none card-custom",
      }}
      footerButtonProps={{
        hidden: true,
      }}
      wrapperProps={{
        className: "base-custom-container",
      }}
      breadcrumb={null}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          form_loading: false,
          name: exploration?.name,
          product_code: exploration?.vizState.product_code,
          description: exploration?.description,
          platform: exploration?.platform,
          "time-range": exploration?.["time-range"],
          "custom-time-range": exploration?.["custom-time-range"],
        }}
      >
        <Card size="small" title={"General Information"} className="  mb-2">
          <div className="flex">
            <div className="w-3/4 mr-4">
              <GeneralInfoWrapper form={form} mode="edit" />
            </div>
            <div id="actions-wrapper" className="self-end 1/4" />
          </div>
        </Card>
        <QueryBuilderChartLayout
          autoSaveId="explore-query-builder-share-view"
          queryBuilderComponent={<ExploreQueryNew />}
          showResultComponent={<ChartResultProvider mode="view" exploration={exploration} form={form} />}
        />

        <Form.Item name="form_loading" hidden>
          <Checkbox />
        </Form.Item>
      </Form>
    </Show>
  );
};
